<script setup lang="ts">
import { cn } from '@/lib/utils'

const props = withDefaults(
    defineProps<{
        placeholder?: string
        modelValue?: FileList | undefined
        multiple?: boolean
        disabled?: boolean
    }>(),
    {
        multiple: false,
        disabled: false,
    }
)

const emits = defineEmits<{
    (e: 'update:modelValue', payload: FileList | undefined): void
}>()

const classes =
    'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground has-focus:border-blue-500 disabled:cursor-not-allowed disabled:opacity-50'

function handleChange(event) {
    const files = (event.target as HTMLInputElement).files
    emits('update:modelValue', files ? Array.from(files) : [])
}
</script>

<template>
    <input
        type="file"
        :multiple="multiple"
        @change="handleChange"
        :class="cn(classes, $attrs.class ?? '')"
        :disabled="disabled"
    />
</template>
